export const theme = {
  colors: {
    primary: '#000000',
    white: '#ffffff',
    secondary: '#f8fafc',
    remondis_accent: '#ed1c24',
    alecta_accent: '#006cf2',
    grayscale: 'rgba(0, 0, 0, 0.4)',
    grayscale_2: 'rgba(0, 0, 0, 0.3)',
    secondary_text: '#4b5563',
    background: '#f9fafb',
    content_background: '#ffffff',
    border: '#e5e7eb',
    selectedBorder: '#197149',
  },
  dimensions: {
    components: {
      borderRadius: '30px',
    },
    card: {
      borderRadius: '40px',
      width: '800px',
      height: '425px',
    },
  },
  columns: {
    gap: '10px',
    gap_small: '5px',
    gap_medium: '10px',
    gap_large: '20px',
    gap_xlarge: '30px',
  },
  segments: {
    columns: 3,
    rows: 3,
  },
  materials: {
    selectedBorder: '#197149',
  },
  contactForm: {
    width: '700px',
  },
};
